import { Button } from '../ui/Button';

type Props = { operations?: string[] };

export function BulkCreativeFactoryBar({ operations = [] }: Props) {
  return (
    <div className="flex flex-wrap items-center gap-2 rounded-lg border border-slate-200 bg-slate-50 p-3 dark:border-slate-700 dark:bg-slate-900">
      <span className="text-xs font-semibold uppercase tracking-wide text-slate-500">Bulk Factory</span>
      {operations.map((op) => (
        <Button key={op} variant="secondary" size="sm">{op}</Button>
      ))}
    </div>
  );
}
